import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { iStoreActions } from '../core/store-actions.interface';
import { ClosingCostWorksheet } from '../../closing-cost-worksheet-15/models/ccw.models';

function createInitialState(): ClosingCostWorksheet {
  return <ClosingCostWorksheet>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-ccw-store' })
export class CmgCcwStore extends Store<ClosingCostWorksheet> implements iStoreActions<ClosingCostWorksheet> {
  private _initValue: ClosingCostWorksheet = null;
  constructor() {
    super(createInitialState());
  }

  preInitialize(ccw: ClosingCostWorksheet): void {
    this.update(ccw);
    this._initValue = JSON.parse(JSON.stringify(this.getValue()));
  }

  get initialValue() {
    return this._initValue;
  }
}
